import { Form, Input, Grid, Select, Field } from "@alifd/next";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
const regexp = new RegExp(/^(?!.*@@).*$/);
const AddDataSet = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, options, ...otherProps } = props;
    const [dataSource, setDataSource] = useState({});
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));

    useEffect(() => {
        fieldRef.current.reset();
    }, []);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, []);

    return (
        <Form field={fieldRef.current} className="bef-custom-dep">
            <Grid.Row gutter="12">
                <Grid.Col>
                    <Form.Item className="custom-form-control" required label="名称" name="Name"  patternMessage="请勿使用@@" pattern={regexp}>
                        <Input />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item className="custom-form-control"  label="描述" name="Description">
                        <Input />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
        </Form>
    );
});
export default AddDataSet;